import { TEXT_PRESET_KEY } from '@optimus-web/local-tokens';
import { Typography } from '../../Typography';
import { TitleProps } from './types';

export const SectionTitle = (props: TitleProps) => <Typography {...props} preset={TEXT_PRESET_KEY['600m']} as="h2" />;
